<div class="qq-summary">
<app-questionnaire-summary title="Summary" [appScrollIntoView]="true" *ngIf="answers">
  <app-summary-row label="Name">
    {{answers.FirstPolicyHolderFirstName}} {{answers.FirstPolicyHolderSurName}}
  </app-summary-row>
  <app-summary-row label="Date of Birth">
    {{answers.FirstPolicyHolderDOB}}
  </app-summary-row>
  <app-summary-row label="Smoker Status">
    {{quickQuote.answerText('FirstPolicyHolderSmoker')}}
  </app-summary-row>
  <app-summary-row label="Type of policy">
    {{answers.TypeOfPolicy_1 === 'SINGLE' ? 'Just me': 'For you and your partner'}}
  </app-summary-row>

  <ng-container *ngIf="answers.TypeOfPolicy_1 === 'DUAL'">
    <app-summary-row label="Second Policy Holder">
      {{answers.SecondPolicyHolderFirstName}} {{answers.SecondPolicyHolderSurName}}
    </app-summary-row>
    <app-summary-row label="Second Policy Holder Date of Birth">
      {{answers.SecondPolicyHolderDOB}}
    </app-summary-row>
    <app-summary-row label="Second Policy Holder Smoker Status">
      {{quickQuote.answerText('SecondPolicyHolderSmoker')}}
    </app-summary-row>
  </ng-container>

  <!-- <app-summary-row label="Cover Type" *ngIf="quickQuote.answersObject['CoverBasis_1']">
    {{quickQuote.answerText('CoverBasis_1')}}
  </app-summary-row> -->

  <div [ngSwitch]="answers.FinancialAllocationType">
    <app-summary-row [label]="sumAssuredLabel" *ngSwitchDefault>
      {{answers.ProtectionLevel_1 | pounds }}
    </app-summary-row>
    <app-summary-row label="Monthly Premium" *ngSwitchCase="'Premium'">
      {{answers.ProtectionLevel_Premium | pounds }}
    </app-summary-row>
  </div>
  <app-summary-row label="Term">
    {{answers.PolicyTerm_1}} years
  </app-summary-row>
  <!-- <app-summary-row label="Critical Illness Cover" *ngIf="quickQuote.answersObject['PolicyType_1']">
    {{quickQuote.answerText('PolicyType_1')}}
  </app-summary-row> -->
</app-questionnaire-summary>

  <div class="qq-summary__comms">
    <form #contactForm="ngForm">
      <app-button-select-question [question]="question"></app-button-select-question>
    </form>

    <p class="disclaimer" *ngIf="disclaimer" [innerHTML]="disclaimer.body"></p>
  </div>

  <div footer>
    <!-- <span>
      How do you want to receive your quote?
    </span>
    <div class="button-select__options">
      <div>
        <ion-checkbox></ion-checkbox>
        <ion-label>Sms</ion-label>
      </div>

      <div>
        <ion-checkbox></ion-checkbox>
        <ion-label>Email</ion-label>
      </div>

      <div>
        <ion-checkbox></ion-checkbox>
        <ion-label>Call</ion-label>
      </div>
    </div> -->
  </div>

  <app-paging [page]="quickQuote.currentPage" [valid]="question.answer"></app-paging>
</div>
